



















































































































import { Component, Vue } from "vue-property-decorator";
import SourceCodeContainer from "@/components/SourceCodeContainer.vue";
@Component({
	name: "ButtonThree",
	components: {
		SourceCodeContainer
	}
})
export default class ButtonThree extends Vue {}
